const usdFormatter: Intl.NumberFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: import.meta.env.VITE_DEFAULT_CURRENCY,
});

export default usdFormatter;
